import styled, { css } from 'styled-components';
import { colors, sizes } from 'stylesheets';

export const Styled = styled.section`
  background: ${({ color }) => color || colors.blueLight};
  display: flex;
  flex-direction: ${({ flexColumn }) => (flexColumn ? 'column' : 'row')};
  flex: 1;
  justify-content: center;
  padding-left: 8.2vw;
  min-height: 100vh;

  ${({ centered }) => centered
    && css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;
